import { render, staticRenderFns } from "./onlineExam.vue?vue&type=template&id=83c90cbe&scoped=true"
import script from "./onlineExam.vue?vue&type=script&lang=js"
export * from "./onlineExam.vue?vue&type=script&lang=js"
import style0 from "./onlineExam.vue?vue&type=style&index=0&id=83c90cbe&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c90cbe",
  null
  
)

export default component.exports